module.exports = __webpack_public_path__ + "img/pets.4cc77361.png";